import Vue from 'vue'
import Vuex from 'vuex'
import host from './host';

// Импортируем наш файл location (он экспортирует объект по дефолту)
import locationModule from './modules/location'; 
// import router from '../router';
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isGuest: false,
    token: localStorage.getItem('AccessToken'),
    refreshToken: localStorage.getItem('RefreshToken'),
    tokenExpires: localStorage.getItem('TokenExpires'),
    userId: localStorage.getItem('UserId'),
    userRole: localStorage.getItem('UserRole'),
    userRoleName: localStorage.getItem('UserRoleName'),
    userName: localStorage.getItem('UserName'),
    // isPrimary: localStorage.getItem('IsPrimary'),
    onMobile: window.innerWidth < 800 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    currentBodyStyle: '',
    theme: 'dark',
    sidebarStyleName: 'sidebar-dark',
    themes: [
      // { key: 'graphite', value: 'Графит' },
      { key: 'dark', value: 'Тёмная' },
      { key: 'light', value: 'Светлая' },
      { key: 'auto', value: 'Авто' },
    ],
    systemSetting: {
      safeMode: true,
      theme: 'dark',
    },
  },
  // Вот сюда подключаем наш модуль location!
  modules: {
    location: locationModule 
  },
  getters: {
    isAuthenticated() {
      return store.state.token && store.state.token.length;
    },
    hasClass(el, className) {
      if (el.classList) {
        return el.classList.contains(className);
      }
      return !!el.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
    },
    isPrimaryAdmin() {
      return store.state.userRole === 1 && store.state.isPrimary;
    },
    isAdmin() {
      return store.state.userRole === 1;
    },
    
  },
  actions: {
    detectDevicePlatform() {
      store.state.onMobile = window.innerWidth < 800 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    setGuest: ({commit}, value) => {
      store.state.isGuest = value && value === true || value === 'true';
      if (store.state.isGuest) localStorage.setItem('is-guest', true);
      else localStorage.removeItem('is-guest');
    },
    loadSettings() {
      let jsonData = localStorage.getItem('system-setting');
      if (jsonData && jsonData.length > 0) {
        const setting = JSON.parse(jsonData);
        Object.keys(store.state.systemSetting).forEach(key => {
          if (Object.hasOwn(setting, key)) {
            store.state.systemSetting[key] = setting[key];
          }
        });
      }
      
      store.dispatch('applyTheme');
    },
    saveSettings() {
      localStorage.setItem('system-setting', JSON.stringify(store.state.systemSetting));
    },
    setBodyClass: ({commit}, styleName) => {
      if (store.state.currentBodyStyle == styleName) return;
      store.dispatch('removeBodyClass');
      // document.body.className += styleName;
      const root = document.getElementsByTagName('html')[0];
      root.setAttribute('class', styleName);
    },
    removeBodyClass() {
      if (store.state.currentBodyStyle && store.state.currentBodyStyle != '')
      store.actions.removeClass(document.body, currentBodyStyle);
      const root = document.getElementsByTagName('html')[0];
      root.setAttribute('class', '');
    },
    addClass(el, className) {
      if (el.classList) {
        el.classList.add(className);
      } else if (!store.getters.hasClass(el, className)) {
        el.className += ` ${className}`;
      }
    },
    removeClass(el, className) {
      if (el.classList) {
        el.classList.remove(className);
      } else if (store.getters.hasClass(el, className)) {
        const reg = new RegExp(`(\\s|^)${className}(\\s|$)`);
        el.className = el.className.replace(reg, ' ');
      }
    },
    applyTheme({commit}) {
      switch (store.state.systemSetting.theme) {
        case 'graphite':
          store.dispatch('setBodyClass', 'options-style');
          store.state.sidebarStyleName = 'options-style';
          break;
        case 'dark':
          store.dispatch('setBodyClass', 'dark-style');
          store.state.sidebarStyleName = 'dark-style';
          break;
        case 'light':
          store.dispatch('setBodyClass', 'light-style');
          store.state.sidebarStyleName = 'light-style';
          break;
        case 'auto':
          let systemTheme = 'light-style';
          if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            systemTheme = 'dark-style'
          }
          store.dispatch('setBodyClass', systemTheme);
          store.state.sidebarStyleName = systemTheme;
          break;
        default:
          store.dispatch('setBodyClass', 'default-style');
          store.state.sidebarStyleName = 'default-style';
          break;
      }
      store.state.theme = getComputedStyle(document.documentElement).getPropertyValue('--theme');
    },
    revokeRefreshToken() {
      try {
        // Используем чистый Vue.http во избежание бесконечного цикла интерцептора
        const response = Vue.http.post(`${host.IdentityServiceApi}/RevokeRefreshToken`, {
          refreshToken: store.state.refreshToken
        });
      } catch {
        // Игнорируем ошибку
      }
    },
    logout() {
      // store.dispatch('unsubscribePushToken');

      store.state.isGuest = false;
      localStorage.removeItem('is-guest');
      store.state.token = null;
      Vue.prototype.$connection.stop();
      localStorage.clear();
      sessionStorage.clear();
      // router.push('/login');
      window.location.href = '/';
    },
    // logout({ commit }) {
    //   commit('CLEAR_USER_DATA');
    //   localStorage.clear();
    //   router.push('/login');
    // },
    updateWebToken: ({commit}, webToken) => {
      store.state.token = webToken.accessToken;
      store.state.refreshToken = webToken.refreshToken;
      store.state.tokenExpires = webToken.expires;

      store.state.role = webToken.role;
      store.state.roleName = webToken.roleName;
      store.state.userId = webToken.id;
      store.state.userName = webToken.userName;

      localStorage.setItem('AccessToken', webToken.accessToken);
      localStorage.setItem('RefreshToken', webToken.refreshToken);
      localStorage.setItem('TokenExpires', webToken.expires);

      localStorage.setItem('UserRole', webToken.role);
      localStorage.setItem('UserRoleName', webToken.roleName);
      localStorage.setItem('UserId', webToken.id);
      localStorage.setItem('UserName', webToken.userName);
    },
    async refreshToken({ commit, state }) {
      try {
        // Используем чистый Vue.http во избежание бесконечного цикла интерцептора
        const response = await Vue.http.post(`${host.IdentityServiceApi}/RefreshToken`, {
          accessToken: store.state.token,
          refreshToken: store.state.refreshToken
        });

        const result = response.body;
        // Коммитим новые данные в стейт и обновляем хранилище
        store.dispatch('updateWebToken', result.token);
        
        return store.state.token; // Возвращаем строку для интерцептора
      } catch (error) {
        // Если бэкенд вернул ошибку, пробрасываем её в интерцептор для вызова logout
        throw error;
      }
    },
  }
})
